import { openTelegramLink } from '@telegram-apps/sdk-react';
import { buildShareUrl } from '../lib/invite-share';
import { isMockedEnv } from './init';

/**
 * Системный share-sheet Telegram через t.me/share/url — работает на всех клиентах.
 * Возвращает false, если шаринг недоступен (браузер, dev-мок) — экран показывает ссылку и «Скопировать».
 *
 * TODO(invite-ux): shareMessage (Bot API 8.0+) даёт красивое inline-сообщение с кнопкой, но требует
 * savePreparedInlineMessage на сервере. Внедрять после того, как бот научится готовить сообщение.
 */
export function shareInviteLink(link: string, text: string): boolean {
  if (isMockedEnv()) return false;
  try {
    if (!openTelegramLink.isAvailable()) return false;
    openTelegramLink(buildShareUrl(link, text));
    return true;
  } catch {
    return false;
  }
}
